import { formatMoney } from '../../lib/utils'
import { mesAno, podeMover, type ModoSaldo } from '../../lib/ajustesImportacao'
import type { ItemPreVisualizacaoCsv, MoverSugeridoCsv } from '../../types'

/** Dentro da célula da descrição: marca "Transferência de saldo" e a opção de mover (marcada por padrão). */
export function AjustesDoItem({ item, destinoRotulo, moverAtivo, moverMarcado, onMover, extra }: {
  item: ItemPreVisualizacaoCsv
  destinoRotulo: string
  /** false quando o mover está bloqueado (fatura paga). */
  moverAtivo: boolean
  moverMarcado: boolean
  onMover: (marcado: boolean) => void
  /** Aviso adicional na célula (ex.: possível duplicada). */
  extra?: string
}) {
  return (
    <>
      {extra && <p className="mt-1 text-2xs text-warning">{extra}</p>}
      {item.saldoTransferido && <p className="mt-1 text-2xs text-warning">Transferência de saldo do mês anterior</p>}
      {podeMover(item) && (
        <label className="mt-1 flex items-center gap-1.5 text-2xs text-white">
          <input type="checkbox" checked={moverAtivo && moverMarcado} disabled={!moverAtivo} onChange={(e) => onMover(e.target.checked)} />
          Mover da fatura de {mesAno(item.faturaAtualMes, item.faturaAtualAno)} para {destinoRotulo}
        </label>
      )}
    </>
  )
}

/** Saldo do mês anterior: zerar a sobra da fatura anterior, com o valor do banco ou o saldo do app. */
export function PainelSaldo({ item, ativo, onAtivo, modo, onModo }: {
  item: ItemPreVisualizacaoCsv
  ativo: boolean
  onAtivo: (v: boolean) => void
  modo: ModoSaldo
  onModo: (m: ModoSaldo) => void
}) {
  const anterior = mesAno(item.faturaAnteriorMes, item.faturaAnteriorAno)
  const app = item.faturaAnteriorTotal ?? 0
  const dif = item.diferenca ?? Math.round((item.valor - app) * 100) / 100
  return (
    <div className="space-y-2 rounded-lg border border-line p-3 text-13">
      <p className="font-medium text-white">Transferência de saldo do mês anterior</p>
      <p className="text-muted">
        "{item.descricao}": banco {formatMoney(item.valor)} × app {formatMoney(app)} na fatura de {anterior}.
        {' '}Diferença: <span className={dif === 0 ? 'text-income' : 'text-warning'}>{formatMoney(dif)}</span>.
      </p>
      <label className="flex items-center gap-2 text-white">
        <input type="checkbox" checked={ativo} onChange={(e) => onAtivo(e.target.checked)} />
        Zerar a sobra da fatura de {anterior}
      </label>
      {ativo && dif !== 0 && (
        <div className="space-y-1 pl-6 text-white">
          <label className="flex items-center gap-2">
            <input type="radio" name="modo-saldo" checked={modo === 'banco'} onChange={() => onModo('banco')} />
            Transferir o valor do banco ({formatMoney(item.valor)})
          </label>
          <label className="flex items-center gap-2">
            <input type="radio" name="modo-saldo" checked={modo === 'app'} onChange={() => onModo('app')} />
            Transferir o saldo do app ({formatMoney(app)})
          </label>
        </div>
      )}
    </div>
  )
}

/** Candidatos a mover que só vieram em divergencias.moverSugeridos (sem o campo no item). */
export function MoverSomenteDivergencia({ lista, destinoRotulo, ativo, off, onToggle }: {
  lista: MoverSugeridoCsv[]
  destinoRotulo: string
  ativo: boolean
  off: Set<string>
  onToggle: (transacaoId: string, marcado: boolean) => void
}) {
  if (lista.length === 0) return null
  return (
    <>
      {lista.map((x) => (
        <label key={x.transacaoId} className="flex items-center gap-2 text-13">
          <input type="checkbox" checked={ativo && !off.has(x.transacaoId)} disabled={!ativo} onChange={(e) => onToggle(x.transacaoId, e.target.checked)} />
          <span className="flex-1 text-white">{x.descricao}: mover da fatura de {mesAno(x.faturaAtualMes, x.faturaAtualAno)} para {destinoRotulo}</span>
          <span className="font-semibold text-white">{formatMoney(x.valor)}</span>
        </label>
      ))}
    </>
  )
}
